function getSeconds() {
  const date = new Date();
  return {
    dia: date.getSeconds() + 60 * date.getMinutes() + 60 * 60 * date.getHours(),
    semana:
      date.getSeconds() +
      60 * date.getMinutes() +
      60 * 60 * date.getHours() +
      60 * 60 * 24 * date.getDay(),
    "3 dias":
      date.getSeconds() + 60 * date.getMinutes() + 60 * 60 * date.getHours(),
  };
}
const secRanges = {
  dia: 60 * 60 * 24,
  semana: 60 * 60 * 24 * 7,
  "3 dias": 60 * 60 * 24 * 3,
};

export default class Line {
  constructor(container, range) {
    this.container = container;
    this.range = range;
    this.line = document.createElement("span");
    this.line.className = "moment-line";
    const position = getSeconds()[range] / secRanges[range];
    this.line.style.left = position * 100 + "%";
    this.container.appendChild(this.line);
  }
  updateRange(newRange) {
    this.range = newRange;
    this.destroy();
    this.line = document.createElement("span");
    this.line.className = "moment-line";
    const position = getSeconds()[newRange] / secRanges[newRange];
    this.line.style.left = position * 100 + "%";
    this.container.appendChild(this.line);
  }

  updateTime(newTime) {
    console.log(newTime);
    this.line.remove();
  }
  destroy() {
    this.line.remove();
  }
}
